// extracted by mini-css-extract-plugin
module.exports = {"word-map":"WordMap_word-map__wvcXk","blocks":"WordMap_blocks__2s81N","item":"WordMap_item__EUFxG","item-word":"WordMap_item-word__1Aqe_"};